import React, { Fragment, useState } from 'react';
import {
    Button,
    Confirm,
    useMutation,
    useRefresh,
    useNotify,
    useUnselectAll
    
} from 'react-admin';

//import Button from '@material-ui/core/Button';

const BulkButtonOnSelected = ({ selectedIds,resource,src,newSatus,buttonLabel,confirmeTitle,confirmeMessage,buttonIcon,style }) => {
   
    const [open, setOpen] = useState(false);
    const refresh = useRefresh();
    const notify = useNotify();
    const unselectAll = useUnselectAll();
    
    const [updateMany, {loading }] = useMutation(
        {
            type:'updateMany',
            resource:src,
            payload:{ids:selectedIds,data:newSatus}
        },
        
        {   
            onSuccess: ({data}) => {      
                notify('Mise à jour effectuée avec succès','info',{},true); 
                unselectAll(resource);
                refresh();
            },
            onFailure: error => {
                //refresh();
                notify('Error: la mise à jour a échoué', 'warning');                
            }
        }
    );
    //console.log(resource);
    const handleClick = () => setOpen(true);
    const handleDialogClose = () => setOpen(false);

    const handleConfirm = () => {
        updateMany();
        //console.log(data)  
        setOpen(false);
    };

    return (
        <Fragment>
            <Button label={buttonLabel}  onClick={handleClick}  style={style}>{buttonIcon}</Button>
            <Confirm
                isOpen={open}
                loading={loading}
                title={confirmeTitle}
                content={confirmeMessage}
                onConfirm={handleConfirm}
                onClose={handleDialogClose}
            />
        </Fragment>
    );
}

export default BulkButtonOnSelected;